// Written by scripts/write-build-info.js at build time. Do not edit.
const buildInfo = {
  "version": "0.1.0",
  "commit": "391a335",
  "builtAt": "2026-10-09T15:23:29.205Z"
};
export default buildInfo;
